import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";
import {
  IAPI_RET004_Request,
  IAPI_RET004_Response,
} from "../../../type/apiType";
import {
  IAPI_COM014_Request,
  IAPI_COM014_Response,
} from "../../../type/apiType";

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

// 退職手当金請求参照
const httpAPI_RET004 = async (
  param: IAPI_RET004_Request
): Promise<IAPI_RET004_Response> => {
  let res = await http.post(ApiUrl.API_RET004, {
    ...param,
  });
  return res.data;
};

// ファイルダウンロード
const httpAPI_COM014 = async (
  param: IAPI_COM014_Request
): Promise<IAPI_COM014_Response> => {
  let res = await http.post(ApiUrl.API_COM014, {
    ...param,
  });
  return res.data;
};

export { httpAPI_RET004, httpAPI_APP016 ,httpAPI_COM014 };
